// extracted by mini-css-extract-plugin
export default {"page":"qoRTRFJc8PW3kpdRTlJj","divider":"vERY89UAYd6o66A34kLP"};